module.exports = __webpack_public_path__ + "static/img/icon.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon.ico
// module id = 759
// module chunks = 34